// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Imprint
require('./../../../Assets/Sass/modal.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

import * as helper from './../../../Assets/Js/helper';

import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {faHeartbeat, faWeight, faRuler} from '@fortawesome/pro-solid-svg-icons';
import {faCheckCircle, faTimesCircle} from '@fortawesome/pro-regular-svg-icons';

library.add(faHeartbeat, faWeight, faRuler, faCheckCircle, faTimesCircle);
dom.watch();

helper.addEventListener(window, 'load', function () {
	const dataHolder = helper.$('#background');
	const ab1 = parseInt(helper.getData(dataHolder, 'ab1'));
	const girlData = JSON.parse(helper.getData(dataHolder, 'girldata'));
	const girlId = parseInt(helper.getData(dataHolder, 'id'));
	const last = helper.$('.last')[0];
	const results = JSON.parse(helper.getData(dataHolder, 'result'));
	const pfm = helper.getData(dataHolder, 'pfm');
	const correctAnswers = girlData.end.valid;
	const $eigenschaften = helper.$('.answerlist')[0];

	let correctCounter = 0;
	let selectedAnswers = [];

	const buttons = helper.$('.continue');
	for (let button of buttons) {
		helper.addEventListener(button, 'click', function(evt) {
			evt.preventDefault();
			let me = evt.target;
			let next = me.getAttribute('href');
			let text = helper.getData(me, 'text');
			let section = me.parentNode.parentNode;
			let nextSection = helper.$(next);
			selectedAnswers.push(text);

			if (correctAnswers.indexOf(text) !== -1) {
				correctCounter++;
			}

			if (last === nextSection) {
				helper.addClass(document.body, 'expanded');
				let percentage = Math.floor(100 / correctAnswers.length * correctCounter);
				if (percentage > 100) {
					percentage = 100;
				}
				helper.$('#percentage').setAttribute('src', `/VX/GirlsQuest/img/percent/${percentage}.png`);
				helper.$('#ctatext').innerHTML = results[percentage];

				for (let correctAnswer of correctAnswers) {
					if (selectedAnswers.indexOf(correctAnswer) === -1) {
						$eigenschaften.innerHTML = $eigenschaften.innerHTML + `<p><span style="color: red;"><i class="far fa-times-circle"></i></span> ${correctAnswer}</p>`;
					} else {
						$eigenschaften.innerHTML = $eigenschaften.innerHTML + `<p><span style="color: green;"><i class="far fa-check-circle"></i></span> ${correctAnswer}</p>`;
					}
				}
			}

			helper.removeClass(section, 'active');
			helper.addClass(section, 'out');
			helper.addClass(nextSection, 'active');

			if (me.classList.contains('play')) {
				helper.$('#video').play();
			}
		});
	}

	helper.addEventListener(helper.$('#cta'), 'click', function (evt) {
		evt.preventDefault();
		let paytourHelper = window.paytourHelper;
		let paytourInitObject = {
			'host': girlId,
			'pfm': pfm,
			'option': 'UMLP25E',
			'hideClose': false,
			'disableJump': true
		};

		if (ab1 === 1) {
			paytourInitObject.option = '2XITGA';
			paytourInitObject.texts = {
				BonusTextCustom: '& erhalte 100% Bonus geschenkt',
				BonusTextCustomSecondary: 'Erhalte 100% Bonus geschenkt!',
				TicketHeadline: 'Sooo Geil!'
			};
		}

		paytourHelper.openPaytour(paytourInitObject);
	});

	helper.addClass(helper.$('#sec0'), 'active');
});
